'use client';

import { __assign } from '../_virtual/_tslib.js';
import { EAlertType } from '../Utils/constants.js';

var EColorName;
(function (EColorName) {
    EColorName["primary"] = "primary";
    EColorName["secondary"] = "secondary";
    EColorName["green"] = "green";
    EColorName["yellow"] = "yellow";
    EColorName["error"] = "error";
    EColorName["neutral"] = "neutral";
    EColorName["grey"] = "grey";
})(EColorName || (EColorName = {}));
var mainColor = {
    0: '#000',
    100: '#fff'
};
var colors = {
    primary: __assign(__assign({}, mainColor), { 10: '#002466', 20: '#003699', 30: '#0047CC', 40: '#005AFF', 50: '#347BFF', 60: '#4D8CFF', 70: '#80ADFF', 80: '#A0C1FF', 90: '#D4E4FF', 95: '#EFF5FF', 99: '#F9FBFF' }),
    secondary: __assign(__assign({}, mainColor), { 10: '#3F1F15', 20: '#7F3F2B', 30: '#BE5E40', 40: '#FF7D55', 50: '#FD916F', 60: '#FEA488', 70: '#FEB8A2', 80: '#FFCBBB', 90: '#FFDFD5', 95: '#FFEFEA', 99: '#FCFBFA' }),
    green: __assign(__assign({}, mainColor), { 10: '#102201', 20: '#214402', 30: '#316503', 40: '#418703', 50: '#609B2D', 60: '#7FAE56', 70: '#9DC27E', 80: '#BCD5A7', 90: '#DCE9D0', 95: '#EFF5EA', 99: '#FAFCF8' }),
    yellow: __assign(__assign({}, mainColor), { 10: '#402C00', 20: '#805800', 30: '#BF8400', 40: '#FFAF00', 50: '#FFBC2B', 60: '#FFCA56', 70: '#FFD780', 80: '#FFE4AA', 90: '#FFF2D5', 95: '#FFF9EC', 99: '#FFFEFC' }),
    error: __assign(__assign({}, mainColor), { 10: '#370E0C', 20: '#6E1B17', 30: '#A52923', 40: '#DC362E', 50: '#E35750', 60: '#EA7872', 70: '#F19895', 80: '#F8B9B7', 90: '#FFDAD9', 95: '#FCEDED', 99: '#FFFAFA' }),
    neutral: __assign(__assign({}, mainColor), { 10: '#1B1E25', 20: '#363C49', 30: '#50596E', 40: '#6B7792', 50: '#838DA3', 60: '#9AA2B4', 70: '#B2B8C5', 80: '#C9CDD6', 90: '#E1E3E8', 95: '#F1F2F4', 99: '#F8F9FA' }),
    grey: __assign(__assign({}, mainColor), { 10: '#1D1D1D', 20: '#333333', 30: '#494949', 40: '#616161', 50: '#797979', 60: '#939393', 70: '#AEAEAE', 80: '#C9C9C9', 90: '#E2E2E2', 95: '#F1F1F1', 99: '#FCFCFC' })
};
var getAlertColorRange = function (type) {
    var _a;
    return type ? (_a = {},
        _a[EAlertType.info] = colors.primary,
        _a[EAlertType.warning] = colors.yellow,
        _a[EAlertType.danger] = colors.error,
        _a[EAlertType.success] = colors.green,
        _a)[type] : colors.primary;
};

export { EColorName, colors, getAlertColorRange };
//# sourceMappingURL=index.js.map
